import { render, staticRenderFns } from "./imageCroppaPicker.vue?vue&type=template&id=196ac344&scoped=true"
import script from "./imageCroppaPicker.vue?vue&type=script&lang=js"
export * from "./imageCroppaPicker.vue?vue&type=script&lang=js"
import style0 from "./imageCroppaPicker.vue?vue&type=style&index=0&id=196ac344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ac344",
  null
  
)

export default component.exports